// extracted by mini-css-extract-plugin
export var container = "_dq-0";
export var infoIcon = "_dq-2";
export var internalLabel = "_dq-3";
export var titleRowCol = "_dq-1";